/* Compact only the optional AI shopping teaser on small screens. */
(() => {
  const styleId = 'fabisense-mobile-agent-style';
  const styles = `@media screen and (max-width:749px) {
    [data-testid="entrypoint"] {
      bottom:76px!important; left:auto!important; right:0!important; margin:12px!important;
      width:max-content!important; max-width:60px!important;
      transform:none!important;
    }
    [data-testid="entrypoint"] > button { display:none!important; }
    [data-testid="entrypoint"] > [role="button"] > div:first-child > div:has(> button[aria-label="Dismiss"]) { display:none!important; }
    [data-testid="entrypoint"] .size-16 { width:44px!important; height:44px!important; }
  }`;
  let attempts = 0;
  const apply = () => {
    const root = document.getElementById('ads-agent-host')?.shadowRoot;
    if (!root) return false;
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = styles;
      root.appendChild(style);
    }
    return true;
  };
  if (apply()) return;
  const timer = window.setInterval(() => {
    if (apply() || ++attempts >= 60) window.clearInterval(timer);
  }, 1000);
})();
